export default import.meta.ROLLDOWN_FILE_URL_VOWv8OSKRfIIh24rTBNP3Q